// ⚠️ 레거시 — 구 정기결제(구독) 신청 페이지. 앱 내 진입점이 없다.
// 6a67cab7 에서 PassItem 의 push(SUBSCRIBE_PAYMENTS) 가 제거되며 링크가 사라졌고,
// 현재 '/subscribe' 를 참조하는 코드는 SUBSCRIBE_PAYMENTS 상수 정의 한 줄뿐이다.
//
// 구독 '관리'는 /mypage/subscription 이 대체하지만, 구독 '신청·결제' 흐름은 아직 대체재가 없다.
// 신규 subscribe 타입의 결제 경로를 설계할 때 SubscribeToPass 의 postMembershipSubscribe 연동을
// 참고할 수 있어 코드를 남겨둔다. 그 경로가 정해지면 이 페이지는 삭제 대상.
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import SubscribeToPass from "@/components/Package/SubscribeToPass";
import CheckLoginDialog from "@/components/modal/CheckLoginDialog";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { useEffect, useState } from "react";
const Subscribe = ()=>{
    const { isLoggedIn  } = useAuthStore();
    const [checkModal, setCheckModal] = useState(false);
    useEffect(()=>{
        if (!isLoggedIn) setCheckModal(true);
    }, [
        isLoggedIn
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SubscribeToPass, {}),
            /*#__PURE__*/ _jsx(CheckLoginDialog, {
                open: checkModal,
                onClose: ()=>{}
            })
        ]
    });
};
export default Subscribe;
